import { AxiosResponse } from 'axios';

import api from '~/services/api';
import { ProductWithoutPictureReportData } from './product-without-picture-report-interface';

const FIELDS_TO_SHOW = 'externalCode,name,brand';

interface GetListParams {
  skip?: number;
  limit?: number;
  queryString?: string;
  hasPictures?: boolean;
}

class ProductWithoutPictureReportServices {
  getList(
    { skip = 0, limit = 10, queryString, hasPictures }: GetListParams,
    opts?: any
  ): Promise<AxiosResponse<ProductWithoutPictureReportData[] | null>> {
    return api.get('/product/minimized', {
      params: {
        skip,
        limit,
        fieldsToShow: FIELDS_TO_SHOW,
        queryString,
        hasPictures
      },
      ...opts
    });
  }

  getListCount(
    {
      queryString,
      hasPictures,
      skip = 0,
      limit = 10
    }: Pick<GetListParams, 'queryString' | 'hasPictures' | 'skip' | 'limit'>,
    opts?: any
  ): Promise<AxiosResponse<number | null>> {
    return api.get('/product/minimized', {
      params: {
        count: true,
        fieldsToShow: FIELDS_TO_SHOW,
        queryString,
        hasPictures,
        skip,
        limit
      },
      ...opts
    });
  }

  getCSV({
    queryString,
    hasPictures
  }: Pick<GetListParams, 'queryString' | 'hasPictures'>): Promise<AxiosResponse<Blob>> {
    return api.get('/product/report/', {
      params: {
        queryString,
        hasPictures
      },
      responseType: 'blob'
    });
  }
}

export default new ProductWithoutPictureReportServices();
